import * as routes from 'router/routes';
import {
  AccountSettingsIcon,
  ActionTrackerIcon,
  ActivityLogIcon,
  AddUsersIcon,
  CreateProjectIcon,
  DashboardPortfolioIcon,
  LogoutIcon,
  ManageUsersIcon,
  OrganisationOverviewIcon,
  OrganisationProjectsIcon,
  PersonalJournalsIcon,
  PersonalProjectsIcon,
  ProjectJournalsIcon,
  SecuritySettingsIcon,
} from 'assets/menuIcons';

export const MENU_ITEM_KEYS = {
  PERSONAL_PROJECTS: 'personal_projects',
  ORGANISATION_PROJECTS: 'organisation_projects',
  DASHBOARD_PORTFOLIO: 'dashboard_portfolio',
  ADD_USERS: 'add_users',
  MANAGE_USERS: 'manage_users',
  ADD_PROJECT: 'add_project',
  SECURITY_SETTINGS: 'security_settings',
  ACCOUNT_SETTINGS: 'account_settings',
  LOGOUT: 'logout',
  ACTIVITY_LOG: 'activity_log',
  ORGANISATION_OVERVIEW: 'organisation_overview',
  PROJECT_JOURNALS: 'project_journals',
  PERSONAL_JOURNALS: 'personal_journals',
  ACTION_TRACKER: 'action_tracker',
};

export const MENU_ITEMS_DATA = {
  [MENU_ITEM_KEYS.PERSONAL_PROJECTS]: {
    itemKey: MENU_ITEM_KEYS.PERSONAL_PROJECTS,
    title: 'Personal projects',
    Icon: PersonalProjectsIcon,
    link: routes.personalProjects,
  },
  [MENU_ITEM_KEYS.ORGANISATION_PROJECTS]: {
    itemKey: MENU_ITEM_KEYS.ORGANISATION_PROJECTS,
    title: 'Organisation projects',
    Icon: OrganisationProjectsIcon,
    link: routes.projectList,
  },
  [MENU_ITEM_KEYS.DASHBOARD_PORTFOLIO]: {
    itemKey: MENU_ITEM_KEYS.DASHBOARD_PORTFOLIO,
    title: 'Dashboard Portfolio',
    Icon: DashboardPortfolioIcon,
    link: routes.dashboardPortfolio,
  },
  [MENU_ITEM_KEYS.ADD_USERS]: {
    itemKey: MENU_ITEM_KEYS.ADD_USERS,
    title: 'Add users',
    Icon: AddUsersIcon,
  },
  [MENU_ITEM_KEYS.MANAGE_USERS]: {
    itemKey: MENU_ITEM_KEYS.MANAGE_USERS,
    title: 'Manage users',
    Icon: ManageUsersIcon,
    link: routes.manageUsers,
  },
  [MENU_ITEM_KEYS.ADD_PROJECT]: {
    itemKey: MENU_ITEM_KEYS.ADD_PROJECT,
    title: 'Add project',
    Icon: CreateProjectIcon,
    link: routes.createProject,
  },
  [MENU_ITEM_KEYS.SECURITY_SETTINGS]: {
    itemKey: MENU_ITEM_KEYS.SECURITY_SETTINGS,
    title: 'Security settings',
    Icon: SecuritySettingsIcon,
    link: routes.securitySettings,
  },
  [MENU_ITEM_KEYS.ACCOUNT_SETTINGS]: {
    itemKey: MENU_ITEM_KEYS.ACCOUNT_SETTINGS,
    title: 'Account Settings',
    Icon: AccountSettingsIcon,
    link: routes.accountSettings,
  },
  [MENU_ITEM_KEYS.LOGOUT]: {
    itemKey: MENU_ITEM_KEYS.LOGOUT,
    title: 'Logout',
    Icon: LogoutIcon,
  },
  [MENU_ITEM_KEYS.ACTIVITY_LOG]: {
    itemKey: MENU_ITEM_KEYS.ACTIVITY_LOG,
    title: 'Activity Log',
    Icon: ActivityLogIcon,
    link: routes.activityLog,
  },
  [MENU_ITEM_KEYS.ORGANISATION_OVERVIEW]: {
    itemKey: MENU_ITEM_KEYS.ORGANISATION_OVERVIEW,
    title: 'Organisation Overview',
    Icon: OrganisationOverviewIcon,
    link: routes.organisationOverview,
  },
  [MENU_ITEM_KEYS.PROJECT_JOURNALS]: {
    itemKey: MENU_ITEM_KEYS.PROJECT_JOURNALS,
    title: 'Project Journals',
    Icon: ProjectJournalsIcon,
    link: routes.projectJournals,
  },
  [MENU_ITEM_KEYS.ACTION_TRACKER]: {
    itemKey: MENU_ITEM_KEYS.ACTION_TRACKER,
    title: 'Action Tracker',
    Icon: ActionTrackerIcon,
    link: routes.actionTracker,
  },
  [MENU_ITEM_KEYS.PERSONAL_JOURNALS]: {
    itemKey: MENU_ITEM_KEYS.PERSONAL_JOURNALS,
    title: 'Personal Journals',
    Icon: PersonalJournalsIcon,
    link: routes.personalJournals,
  },
};
